var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { ProductInstancePartAvailabilityService, } from "../ordering";
import { PProductConfigCreatorFactory } from "./PProductConfigCreatorFactory";
import { PProductInstanceCreatorPart } from "./PProductInstanceCreatorPart";
import { PRestaurant } from "./PRestaurant";
let PProductInstanceCreatorPartFactory = class PProductInstanceCreatorPartFactory {
    constructor(pProductConfigCreatorFactory, productInstancePartAvailabilityService, restaurant) {
        this.pProductConfigCreatorFactory = pProductConfigCreatorFactory;
        this.productInstancePartAvailabilityService = productInstancePartAvailabilityService;
        this.restaurant = restaurant;
        makeImmutable(this);
    }
    create(params) {
        const productType = this.restaurant.productTypes.get(params.productTypeId);
        const partConfigCreator = this.pProductConfigCreatorFactory.create({
            domain: params.domain.productConfigCreator,
            modifierOrder: productType.divisibleModifiersOrder,
        });
        return new PProductInstanceCreatorPart({
            domain: params.domain,
            productInstancePartAvailabilityService: this.productInstancePartAvailabilityService,
            productType,
            partConfigCreator,
            possibleProductTypes: params.possibleProductTypes,
            restaurant: this.restaurant,
        });
    }
};
PProductInstanceCreatorPartFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PProductConfigCreatorFactory !== "undefined" && PProductConfigCreatorFactory) === "function" ? _a : Object, typeof (_b = typeof ProductInstancePartAvailabilityService !== "undefined" && ProductInstancePartAvailabilityService) === "function" ? _b : Object, typeof (_c = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _c : Object])
], PProductInstanceCreatorPartFactory);
export { PProductInstanceCreatorPartFactory };
